<tds-side-menu aria-label="Side menu" persistent [open]="mobileNavOpen()">
  <tds-side-menu-overlay (click)="toggleMobileSideMenu()" slot="overlay"></tds-side-menu-overlay>

  <tds-side-menu-close-button slot="close-button" (click)="toggleMobileSideMenu()"></tds-side-menu-close-button>


  @for(navItem of navItems; track navItem.label) {
    @if(navItem.children){
      <tds-side-menu-dropdown *appHasRole="navItem.roles" id="wheel-types-dropdown" [selected]="isActiveChild(navItem)" default-open selected>
        @if (navItem.icon) {
          <tds-icon slot="icon" [name]="navItem.icon" size="24px"></tds-icon>
        }
        <span slot="label">{{ navItem.label }}</span>
        <tds-side-menu-dropdown-list style="z-index: 99">
          @for(childItem of navItem.children; track childItem.label) {
            <tds-side-menu-dropdown-list-item [selected]="isActive(childItem.route)" *appHasRole="childItem.roles">
              <button [routerLink]="childItem.route" (click)="toggleMobileSideMenu()">
                @if(childItem.icon) {
                  <tds-icon [name]="childItem.icon" size="24"></tds-icon>
                }
                {{ childItem.label }}
              </button>
            </tds-side-menu-dropdown-list-item>
          }
        </tds-side-menu-dropdown-list>
      </tds-side-menu-dropdown>
    } @else {
      <tds-side-menu-item *appHasRole="navItem.roles" [selected]="isActive(navItem.route)">
        <button [routerLink]="navItem.route" (click)="toggleMobileSideMenu()">
          @if(navItem.icon) {
            <tds-icon [name]="navItem.icon" size="24"></tds-icon>
          }
          {{ navItem.label }}
        </button>
      </tds-side-menu-item>
    }
  }

  <tds-side-menu-collapse-button slot="sticky-end"></tds-side-menu-collapse-button>
</tds-side-menu>